import React from 'react';
import { Box } from '@chakra-ui/react';
import { useSync } from '../context/SyncContext';

interface SyncMarkerProps {
  trackNumber: number;
  duration: number;
}

export const SyncMarker: React.FC<SyncMarkerProps> = ({ trackNumber, duration }) => {
  const { syncPoints } = useSync();
  const syncPoint = syncPoints.get(trackNumber);

  if (syncPoint === undefined) return null;

  return (
    <Box
      position="absolute"
      bottom={0}
      left={`${(syncPoint / duration) * 100}%`}
      width={0}
      height="100%"
      pointerEvents="none"
      zIndex={2}
      _before={{
        content: '""',
        position: 'absolute',
        bottom: '2px',
        left: '-6px',
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: '8px solid',
        borderBottomColor: 'accent.400',
      }}
    />
  );
}; 